import React from 'react';
import { CheckCircleIcon, AlertTriangleIcon, InfoIcon, ShieldCheckIcon } from 'lucide-react';
/**
 * Side-by-side current lineup cards: Gen 3 (highlighted) and Gen 2.
 * Self-contained product cards — not shared with other pages.
 */
export function CurrentLineup() {
  return <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-249">
      {/* Gen 3 */}
      <div className="bg-white rounded-2xl shadow-lg border-2 border-blue-500 overflow-hidden relative flex flex-col" data-id="element-250">
        <div className="absolute top-0 right-0 bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-bl-lg uppercase tracking-wider z-10" data-id="element-251">
          Newest Generation
        </div>
        <div className="p-8 bg-gradient-to-b from-blue-50 to-white flex-grow" data-id="element-252">
          <div className="w-full aspect-square mb-6 bg-white rounded-xl p-4 shadow-sm flex items-center justify-center" data-id="element-253">
            <img src="https://cdn.magicpatterns.com/uploads/cViGkDXcDmPVipYt9uyQmt/Gen3_E-Foot_Gear.jpg" alt="Gen3 E-Foot Gear" className="block max-w-full max-h-full object-contain" data-id="element-254" />
          </div>
          <h2 className="text-2xl font-black text-gray-900 mb-3" data-id="element-255">
            Gen 3 WT Taekwondo Sensor Sock
          </h2>
          <p className="text-gray-600 mb-6" data-id="element-256">
            The latest evolution in electronic scoring, featuring redesigned
            sensor placement for unmatched precision and a better fit.
          </p>
          <div className="space-y-3" data-id="element-257">
            <div className="flex items-start gap-3" data-id="element-258">
              <CheckCircleIcon className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-259" />
              <span className="text-sm font-medium text-gray-800" data-id="element-260">
                Designed specifically for the Gen 3 electronic scoring ecosystem
              </span>
            </div>
            <div className="flex items-start gap-3 bg-red-50 p-3 rounded-lg border border-red-100" data-id="element-261">
              <AlertTriangleIcon className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-262" />
              <span className="text-sm font-bold text-red-900" data-id="element-263">
                MUST be used with Gen 3 Electronic Protector (E-Hogu) ONLY
              </span>
            </div>
          </div>
        </div>
        <div className="p-6 bg-gray-50 border-t border-gray-100 mt-auto" data-id="element-264">
          <a href="/shop/gen-3/" className="block w-full text-center bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-lg transition-colors" data-id="element-265">
            Shop Gen 3 Footgear
          </a>
        </div>
      </div>

      {/* Gen 2 */}
      <div className="bg-white rounded-2xl shadow-md border border-gray-200 overflow-hidden flex flex-col" data-id="element-266">
        <div className="p-8 flex-grow" data-id="element-267">
          <div className="w-full aspect-square mb-6 bg-gray-50 rounded-xl p-4 flex items-center justify-center" data-id="element-268">
            <img src="https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FDaedo%2FGeneration2%2Fepro29037_1_optimizacionweb.jpg" alt="Gen2 E-Foot Gear" className="block max-w-full max-h-full object-contain" data-id="element-269" />
          </div>
          <h2 className="text-2xl font-black text-gray-900 mb-3" data-id="element-270">
            Gen 2 WT Taekwondo Sensor Sock
          </h2>
          <p className="text-gray-600 mb-6" data-id="element-271">
            The established standard for Gen 2 setups, still widely used in many
            regional and national tournaments.
          </p>
          <div className="space-y-3" data-id="element-272">
            <div className="flex items-start gap-3" data-id="element-273">
              <ShieldCheckIcon className="w-5 h-5 text-gray-600 flex-shrink-0 mt-0.5" data-id="element-274" />
              <span className="text-sm font-medium text-gray-800" data-id="element-275">
                The standard for legacy Gen 2 setups
              </span>
            </div>
            <div className="flex items-start gap-3" data-id="element-276">
              <InfoIcon className="w-5 h-5 text-gray-600 flex-shrink-0 mt-0.5" data-id="element-277" />
              <span className="text-sm font-medium text-gray-800" data-id="element-278">
                Still relevant where Gen 2 equipment is actively used
              </span>
            </div>
          </div>
        </div>
        <div className="p-6 bg-gray-50 border-t border-gray-100 mt-auto" data-id="element-279">
          <a href="/shop/daedo-pss-system/" className="block w-full text-center bg-gray-800 hover:bg-gray-900 text-white font-bold py-3 px-4 rounded-lg transition-colors" data-id="element-280">
            Shop Gen 2 Footgear
          </a>
        </div>
      </div>
    </div>;
}